var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 148.4 36",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 606,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.3 29.1c.4-.1.6-.3.6-.7 0-.5-.3-.7-.9-.7h-1v2.5h.4v-1.1h.4l.7 1.1h.4zm-.4-.3h-.4V28h.5c.3 0 .6 0 .6.4s-.3.4-.7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146 26.6c-1.3 0-2.4 1-2.4 2.4 0 1.3 1 2.4 2.4 2.4 1.3 0 2.4-1 2.4-2.4-.1-1.4-1.1-2.4-2.4-2.4zm0 4.4c-1.1 0-2-.9-2-2.1s.9-2.1 2-2.1 2 .9 2 2.1-.9 2.1-2 2.1zM0 5.3h5.6v20.3h10.2v5.1H0zM18.3 13.5h5.3v17.2h-5.3zM21 4.9c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1-3.1-1.4-3.1-3.1 1.3-3.1 3.1-3.1M45.9 5.3h5.4v15.2l6-7h6.6l-7 7.9 6.8 9.3H57l-5.7-8.5v8.5h-5.4zM26.6 13.5h5.1v2.3h.1c.7-1.4 2.5-2.8 5.1-2.8 5.4 0 6.4 3.6 6.4 8.2v9.4H38v-8.4c0-2 0-4.6-2.8-4.6S32 19.8 32 22v8.5h-5.3v-17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1 20.1c0-1.8-1.4-3.3-3.3-3.3-2.3 0-3.6 1.6-3.8 3.3zm4.5 7.6c-1.7 2.2-4.5 3.4-7.3 3.4-5.3 0-9.6-3.6-9.6-9.1s4.3-9.1 9.6-9.1c5 0 8.1 3.6 8.1 9.1v1.7H68c.4 2 2 3.3 4 3.3 1.7 0 2.9-.9 3.8-2.1zM91.5 17.6c-2.7 0-4.3 1.8-4.3 4.4s1.6 4.4 4.3 4.4 4.3-1.8 4.3-4.4-1.6-4.4-4.3-4.4m9.2 13.1h-4.9v-2.3h-.1c-.8 1.2-2.9 2.7-5.3 2.7-5.1 0-8.5-3.7-8.5-8.9 0-4.8 3-9.2 7.9-9.2 2.2 0 4.3.6 5.5 2.3h.1v-10h5.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.4 0h-30.7c-1.5 0-2.7 1.2-2.7 2.6v30.8c0 1.4 1.2 2.6 2.7 2.6h30.7c1.5 0 2.7-1.2 2.7-2.6V2.6c0-1.4-1.2-2.6-2.7-2.6z",
    fill: "#006192"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.4 13.5h5.3v17.2h-5.3zm2.7-8.5c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1-3.1-1.4-3.1-3.1c0-1.8 1.4-3.1 3.1-3.1M120.1 13.5h5.1v2.3h.1c.7-1.4 2.5-2.8 5.1-2.8 5.4 0 6.4 3.6 6.4 8.2v9.4h-5.3v-8.4c0-2 0-4.6-2.8-4.6s-3.2 2.2-3.2 4.4v8.5h-5.3v-17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6f1fc8480bef6c031cabe2cabd7a0c22.svg";
export { ForwardRef as ReactComponent };